import { AgreementCustomer, PaymentMethod } from "@/domain/payments/payments";
import { PaymentFormValues } from "./PaymentAccreditationForm";
import { UpdateAgreementPaymentRequest } from "@/rest/modules/payments-api";
import { useUpdatePayment } from "@/hooks/api/usePayments";
import { useNavigate } from "@tanstack/react-router";
import { Paths } from "@/routes/paths";
import { useEffect } from "react";

export const useOnSubmit = ({ contractId, paymentId, amountToCharge, customer }: { contractId: string, paymentId: string, amountToCharge: number, customer: AgreementCustomer | undefined }) => {
  const updatePayment = useUpdatePayment()
  const navigate = useNavigate();

  const onSubmit = (values: PaymentFormValues) => {
    if (!customer || (!customer.customerDocNumber && !customer.payerDocNumber)) {
      alert('Datos de facturación del cliente incompletos')
      return;
    }
    if (amountToCharge <= 0) return;

    const cardInterest = values.paymentMethod === PaymentMethod.CREDIT_CARD ? (values.interestAmount || 0) : 0;
    const request: UpdateAgreementPaymentRequest = {
      payment: {
        paymentMethod: values.paymentMethod,
        paymentMethodDetails: ((values.paymentMethod === PaymentMethod.CREDIT_CARD || values.paymentMethod === PaymentMethod.DEBIT_CARD) && values.paymentDetails)
          ? JSON.stringify({ couponCode: values.paymentDetails })
          : values.paymentDetails,
        amount: amountToCharge - cardInterest,
        collectorId: values.collectorId,
      },
      invoice: {
        billingType: values.billingType,
        // customerName: customer.customerName ?? customer.payerName,
        // customerCuit: customer.customerDocNumber ?? customer.payerDocNumber,
        // customerAddress: customer.customerAddress ?? customer.payerAddress,
        // customerIvaCondition: customer.customerIvaCondition,
      },
      interestAmount: cardInterest || undefined,
    };
    updatePayment.mutate({ contractId, paymentId, data: request });
  };

  useEffect(() => {
    if (updatePayment.data?.jobId) {
      navigate({
        to: `${Paths.Management.PaymentInvoices}/${paymentId}?jobId=${updatePayment.data.jobId}`,
      });
    }
  }, [updatePayment.data?.jobId, navigate, paymentId]);

  return { onSubmit, isPending: updatePayment.isPending }
}